export default __webpack_public_path__ + "static/media/4-defects.9a07bede.png";